export  const languages = {
   english: "ENG",
   german: "DE",
 };
export  const intlPaths = {
   english: "/en",
 };